import React, { Component } from 'react';
import defaultImageUrl from './item/tile-loading.gif';
import './item.css';

class Item extends Component {

  render() {
    const impressionFigures = (
      <li className="impressions">
        <span>{this.props.impressionCount}</span>
        <span>impressions</span>
      </li>
    );
    const viewFigures = (
      <li className="views">
        <span>{this.props.viewCount}</span>
        <span>views</span>
      </li>
    );
    let figures;
    if (this.props.reverseFigures === '1') {
      figures = (
        <ul className="figures">
          {viewFigures}
          {impressionFigures}
        </ul>
      );
    } else {
      figures = (
        <ul className="figures">
          {impressionFigures}
          {viewFigures}
        </ul>
      );
    }
    let img;
    if (this.props.imageSrc === '#')
      img = <img src={defaultImageUrl} alt="" />;
    else
      img = <img src={this.props.imageSrc} alt="" />;
    return (
      <div className="Item">
        <a href={this.props.linkHref}>
          {img}
          {figures}
        </a>
      </div>
    );
  }

}

export default Item;



// WEBPACK FOOTER //
// ./src/app/stats/container/impressions-and-views/item.js